import Vue from 'vue'
import App from './App'
import './router/index' 
import router from './router/routers'
import store from './store'
import Element from 'element-ui'
import '@/assets/styles/element-variables.scss'

import '@/assets/styles/index.scss'
import '@/utils/m-320'
// 移动端手势
import '@/utils/tap'

import { device } from '@/utils/index'
Vue.prototype.device = device

import tipsDialog from "@/utils/tipsDialog.js"
Vue.prototype.$tipsDialog = tipsDialog

import vDrag from "@/utils/v-drag.js"
//公用组件
Vue.use(vDrag,{directiveName:'drag'});

Vue.use(Element)
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  // 注册全局事件总线（$bus 可以任意命名，一般约定用 $bus））
  beforeCreate() {
    Vue.prototype.$bus = this;
  }
})
